<template>
  <b-overlay :show="loading || !pharmacyData">
    <validation-observer ref="pharmacyForm" #default="{invalid}">
      <div class="flex-div">
        <b-button
          v-if="can('pharmacies:CanApprove')"
          block
          type="submit"
          class="mb-5 mx-2 approve-btn"
          variant="success" 
          style="width: 150px"
          :disabled="loading || pharmacyData.status === 'approved'"
          @click="approvePharmacy(pharmacyData.id)"
        >
          <feather-icon icon="UserCheckIcon" />
          <span class="align-middle ml-50">Approve</span>
        </b-button>

        <b-button
          v-if="can('pharmacies:CanDecline')"
          block
          type="submit"
          class="mb-5 mx-2 decline-btn"
          variant="danger"
          style="width: 150px"
          :disabled="loading || pharmacyData.status === 'declined' || pharmacyData.status === 'approved'"
          @click="declinePharmacy(pharmacyData.id)"
        >
          <feather-icon icon="UserXIcon" />
          <span class="align-middle ml-50">Decline</span>
        </b-button>
      </div>
      
      <b-form v-if="pharmacyData" ref="form" @submit.prevent="updatePharmacy">
        <b-row>
          <b-col cols="12" xl="6" md="6">
            <b-card no-body>
              <div class="logo-wrapper">
                <div>
                  <b-media class="">
                    <b-avatar ref="previewEl" badge-variant="transparent" :src="avatarPath" :text="avatarText(`${pharmacyData.facility_details.pharmacy_name} ${pharmacyData.facility_details.pharmacy_name}`)" :variant="`light-${resolveStatusVariant(getLoanStatusTextForClient(getValueFromSource(pharmacyData, 'status')))}`" size="10rem" class="square-avatar">
                      <template #badge>
                        <b-button variant="primary" class="btn-icon rounded-circle" @click="$refs.avatar.$el.childNodes[0].click()">
                          <feather-icon icon="CameraIcon" />
                        </b-button>
                      </template>
                    </b-avatar>
                  </b-media>
                  <div>
                    <b-form-file v-show="false" ref="avatar" accept="image/*" placeholder="" no-drop @input="onImageRenderer" />
                  </div>
                </div>
              </div>
              <b-card-body class="pt-2">
                <b-form-group label="Pharmacy Name" label-for="pharmacy_name">
                  <validation-provider
                    #default="{ errors }"
                    name="Pharmacy name"
                    rules="required"
                  >
                    <b-form-input
                      id="pharmacy_name"
                      v-model="pharmacyData.facility_details.pharmacy_name"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-card-body>

              <b-card-body class="pt-0">
                <b-form-group label="Pharmacy Phone" label-for="pharmacy_phone">
                  <validation-provider
                    #default="{ errors }"
                    name="Pharmacy phone"
                    rules="required"
                    vid="pharmacy_phone"
                  >
                    <b-form-input
                      id="pharmacy_phone"
                      v-model="pharmacyData.facility_details.pharmacy_phone"
                      :state="errors.length > 0 ? false : null"
                      name="register-phone"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-card-body>

              <b-card-body class="pt-0">
                <b-form-group label="Pharmacy Email" label-for="pharmacy_email">
                  <validation-provider
                    #default="{ errors }"
                    name="Pharmacy Email"
                    rules=""
                  >
                    <b-form-input
                      id="pharmacy_email"
                      v-model="pharmacyData.facility_details.pharmacy_email"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-card-body>
              
              <b-card-body class="pt-0">
                <b-form-group label="Pharmacy Address" label-for="pharmacy_address">
                  <validation-provider
                    #default="{ errors }"
                    name="Pharmacy Address"
                    rules=""
                  >
                    <b-form-input
                      id="pharmacy_address"
                      v-model="pharmacyData.facility_details.pharmacy_address"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-card-body>

              <b-card-body class="pt-0">
                <b-form-group label="Pharmacy Website" label-for="pharmacy_website">
                  <validation-provider
                    #default="{ errors }"
                    name="Pharmacy Website"
                    rules=""
                  >
                    <b-form-input
                      id="pharmacy_website"
                      v-model="pharmacyData.facility_details.pharmacy_website"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-card-body>

            <b-button
              block
              type="submit"
              class="mb-5 mx-2"
              variant="primary"
              style="width: 150px"
              :disabled="invalid || loading"
            >
              Update
            </b-button>
            </b-card>
          </b-col>
        </b-row>
      </b-form>
      <b-row>
      </b-row>
    </validation-observer>
  </b-overlay> 
</template>

<script>
  import { get } from "lodash";
  import { ValidationProvider, ValidationObserver } from "vee-validate";
  import { 
    BAlert, 
    BAvatar, 
    BBadge, 
    BImg, 
    BCard, 
    BCol, 
    BLink, 
    BRow, 
    BCardImg, 
    BFormFile,  
    BMedia,
    BOverlay,
    BDropdown,
    BDropdownItem,
    BCardBody,
    BButton,
    BFormGroup,
    BForm,
    BFormInput, } from "bootstrap-vue"
  import useJwt from "@/auth/jwt/useJwt";
  import VueEasyLightbox from 'vue-easy-lightbox';
  import ListTable from "@core/components/ListTable/ListTable.vue";
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
  // import {
  // required,
  // email
  // } from '@validations'

  export default {
    components: {
      ListTable,
      VueEasyLightbox,
      BAlert, 
      BAvatar, 
      BBadge, 
      BImg, 
      BCard, 
      BCol, 
      BLink, 
      BRow, 
      BCardImg,   
      BMedia,
      BOverlay,
      BDropdown,
      BDropdownItem,
      BCardBody,
      BFormFile,
      BButton,
      BFormGroup,
      BForm,
      BFormInput,
      // validations
      ValidationProvider,
      ValidationObserver,
  },
    directives: {},
    data(){
      return {
        loading: false,
  
        pharmacyData: null,
        avatarPath: "",
        updatedImage: null,
      }
    },
    created() {
      this.fetchPharmacyData();
    },
    methods: {
      async approvePharmacy(pharmacy_id) {
        try {
        this.loading = true;

        if (!this.can(`pharmacies:CanApprove`)) {
          return
        }

        const activateConfirmation = await this.$swal({
          title: 'Approve this Pharmacy?',
          text: "Do you want to approve this pharmacy?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, proceed!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        })

        if (!activateConfirmation.value){
          return;
        }

        await useJwt.mainService.pharmacies.approve(pharmacy_id, { status: "approved" });

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success!',
            variant: 'success',
            icon: 'CheckCircleIcon',
            text: `Pharmacy approved successfully`
          },
        });

        this.fetchPharmacyData()
      } catch (error){
        const error_message = get(error, "response.data.message") || error.message
        this.errorMessage = error_message;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false;
      }
      },
      async declinePharmacy(pharmacy_id) {
        try {
        this.loading = true;

        if (!this.can(`pharmacies:CanDecline`)) {
          return
        }

        const activateConfirmation = await this.$swal({
          title: 'Decline this Pharmacy?',
          text: "Do you want to decline this pharmacy?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, proceed!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        })

        if (!activateConfirmation.value){
          return;
        }

        await useJwt.mainService.pharmacies.decline(pharmacy_id, { status: "declined" });

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success!',
            variant: 'success',
            icon: 'CheckCircleIcon',
            text: `Pharmacy declined successfully`
          },
        });

        this.fetchPharmacyData()
      } catch (error){
        const error_message = get(error, "response.data.message") || error.message
        this.errorMessage = error_message;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false;
      }
      },
      async updatePharmacy(){
      try {
        this.loading = true
        this.error = "";

        const success = await this.$refs.pharmacyForm.validate();
        if (!success) {
          throw new Error("Please check and make sure all fields are valid");
        }

        const formData = new FormData();

        formData.append("pharmacy_name", this.pharmacyData.facility_details.pharmacy_name);
        formData.append("pharmacy_phone", this.pharmacyData.facility_details.pharmacy_phone);
        formData.append("pharmacy_email", this.pharmacyData.facility_details.pharmacy_email);

        formData.append("pharmacy_address", this.pharmacyData.facility_details.pharmacy_address);
        formData.append("pharmacy_website", this.pharmacyData.facility_details.pharmacy_website);

        if (this.updatedImage) {
        formData.append("avatar", this.updatedImage);
        }

        const { id } = this.pharmacyData
        await this.useJwt().mainService.pharmacies.update(id, formData);

        if (this.updatedImage){
          this.updatedImage = null;
        }

        this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: `Update successful`,
          icon: 'CoffeeIcon',
          variant: 'success',
          text: `You have successfully updated your informations.`,
        },
        });
      } catch (error) {
        console.log(error);
        const error_message = get(error, "response.data.message") || error.message
        console.log("error_message", error_message)
        this.error = error_message
      } finally {
        this.loading = false;
      }
      },
      async fetchPharmacyData(){
        try {
          this.loading = true;
          const { id } = this.$route.params;
  
          const response = await this.useJwt().mainService.pharmacies.fetch(id);
          this.pharmacyData = get(response, 'data.data');
          if (this.pharmacyData.facility_details.avatar.path) {
            this.avatarPath = this.pharmacyData.facility_details.avatar.path
          }
        } catch (error){
          this.pharmacyData = undefined;
  
          const error_message = get(error, "response.data.message") || error.message
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error!',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              text: error_message
            },
          });
        } finally {
          this.loading = false
        }
      },
      onImageRenderer(file) {
        const reader = new FileReader()

        reader.addEventListener(
          'load',
          () => {
            this.avatarPath = reader.result
            this.updatedImage = file;
          },
          false,
        )

        if (file) {
        reader.readAsDataURL(file)
        }
      },
      onRefreshRef(ref){
        if (this.$refs[ref]){
          this.$refs[ref].fetchAllData();
        }
      }
    }
  }
</script>
  
<style lang="scss">
  small {
    font-size: 10px;
  }

  .flex-div {
    display: flex;
    align-items: center;
    margin-bottom: -20px !important;
  }

  .approve-btn {
    margin-top: 8px !important;
  }

  .square-avatar {
    border-radius: 0 !important; 
  }

  .logo-wrapper {
    margin-top: 20px;
    text-align: center
  }
</style>
